import { useMemo } from 'react';
import { useLocation } from '@common/hooks';

// TODO(@trusted/works-client-admin): change this when react-router gets updated to v6
export function useQueryParams() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

export function useQueryParam(key: string) {
  const queryParams = useQueryParams();

  return useMemo(() => queryParams.get(key), [queryParams, key]);
}
